/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=751c5ace&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__